// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import Loading from 'react-loading';

// Styles
import '../../styles/investments.css';

export default class Metric extends React.Component {
    render = () => {
        return (<div className="investments-metric">
            <div className="investments-metric-value">{this.props.value === undefined ? <div className="investments-metric-loading">
                <Loading
                    type="bubbles"
                    color="var(--color-primary)"
                    height={32}
                    width={32}
                />
            </div> : this.props.value}</div>
            <div className="investments-metric-label">{this.props.label}</div>
        </div>);
    }
}